import React from 'react';
import { Fragment as _Fragment } from "theme-ui/jsx-runtime";
import { jsx as _jsx } from "theme-ui/jsx-runtime";
export default (function (_ref) {
  var when = _ref.when,
      children = _ref.children;
  return when ? children : _jsx(_Fragment, {});
});
//# sourceMappingURL=filtered.js.map